import styled from 'styled-components';

const StyledWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export { StyledWrapper };
